// src/api/invoiceConfigApi.js
import axiosClient from "./axiosClient";

const invoiceConfigApi = {
  UpsertInvoiceConfig: (data) => {
    return axiosClient.post("/invoice_configs/upsert", data, {
      withCredentials: true,
    });
  },
  GetInvoiceConfig: (CusId) => {
    return axiosClient.get(`/invoice_configs/${CusId}`, {
      withCredentials: true,
    });
  },
};

export default invoiceConfigApi;
